import React, { useState, useEffect } from 'react';

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const btnStyle = {
    position: 'fixed',
    bottom: '90px',
    right: '28px',
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    background: '#0bb4aa',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    boxShadow: '0 2px 12px rgba(11,180,170,0.35)',
    zIndex: 9997,
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateY(0)' : 'translateY(12px)',
    pointerEvents: visible ? 'auto' : 'none',
    transition: 'opacity 0.3s ease, transform 0.3s ease, background 0.2s ease',
  };

  return (
    <button
      onClick={scrollToTop}
      style={btnStyle}
      aria-label="Back to top"
      onMouseEnter={(e) => (e.currentTarget.style.background = '#0da69d')}
      onMouseLeave={(e) => (e.currentTarget.style.background = '#0bb4aa')}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="18 15 12 9 6 15" />
      </svg>
    </button>
  );
}

export default BackToTop;
